import * as React from 'react';
import locales from '../locales';

const NUMBER_FORMAT_HU = new Intl.NumberFormat('hu');

export function groupNumber(num: number | null | undefined): string | undefined {
  // TODO refactor: num shouldn't be undefined (needs DTO refactor)
  const hasNum = num !== undefined && num !== null;
  return hasNum ? NUMBER_FORMAT_HU.format(num!) : undefined;
}

export const numberGroupFormatter = (value: number | string | undefined): string => {
  if (value === '') {
    return value;
  }

  let strValue = String(value);

  // Replace dot with comma for Hungarian format
  strValue = strValue.replace('.', ',');

  // Split by comma to separate integer and decimal parts
  const parts = strValue.split(',');
  const integerPart = parts[0];
  const decimalPart = parts[1];


  // Group integer part in groups of 3 from behind, separated by space
  const grouped = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  // Concatenate back with decimal part if it exists
  return decimalPart !== undefined ? `${grouped},${decimalPart}` : grouped;
};

export const numberGroupParser = (displayValue: string | undefined): React.ReactText => {
  return displayValue?.replace(/\s/g, '').replace(',', '.')  ?? '';
};

export function withCurrency(node: React.ReactNode): React.ReactNode {
  return node ? <>{node} {locales.app_currency}</> : undefined;
}

export function alignRightNoWrap(content: React.ReactNode): React.ReactNode {
  return <div style={{textAlign: 'right', whiteSpace: 'nowrap'}}>{content}</div>;
}

function isNotEmpty(num: number | null | undefined) {
  return num !== undefined && num !== null;
}

export function renderPriceColumn(num: number | null | undefined): React.ReactNode {
  return isNotEmpty(num) && alignRightNoWrap(withCurrency(groupNumber(num)));
}

export function renderFixedPriceColumn(num: number | null | undefined): React.ReactNode {
  return isNotEmpty(num) && withCurrency(numberGroupFormatter(Number(num?.toFixed(0))));
}

export function renderHoursColumn(num: number | null | undefined): React.ReactNode {
  return renderUnitColumn(num, locales.hours);
}

export function renderMmColumn(num: number | null | undefined): React.ReactNode {
  return renderUnitColumn(num, locales.mm);
}

export function renderUnitColumn(num: number | null | undefined, unit: string): React.ReactNode {
  return isNotEmpty(num) && alignRightNoWrap(`${groupNumber(num)} ${unit}`);
}



// WEBPACK FOOTER //
// ./src/utils/number-utils.tsx